import { render, staticRenderFns } from "./LinkWidget.vue?vue&type=template&id=f3f6538c&scoped=true&"
import script from "./LinkWidget.vue?vue&type=script&lang=js&"
export * from "./LinkWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f6538c",
  null
  
)

export default component.exports